module.exports = __webpack_public_path__ + "media/bootstrap-icons/check-056ed31e.svg";